import { z } from 'zod';

import { CustomsStateNotificationType, SortDirection, TSDStatus, TSDType } from '@e-origin/shared';

export const TSDRetrieveCriteriaSchema = z.object({
  filters: z.object({
    searchQuery: z.string().optional(),
    status: z.array(z.nativeEnum(TSDStatus)).optional(),
    type: z.nativeEnum(TSDType),
    filterByNotifications: z.array(z.nativeEnum(CustomsStateNotificationType)).optional(),
  }),
  pagination: z.object({
    page: z.number(),
    size: z.number(),
  }),
  sorting: z.object({
    field: z.string(),
    direction: z.enum([SortDirection.ASC, SortDirection.DESC]),
  }),
});
export type TSDRetrieveCriteriaSchemaData = z.infer<typeof TSDRetrieveCriteriaSchema>;
